<template>

    <main class="category" v-if="category!=null">

        <header class="category-header">
            <div class="heading-container">
                <div class="image-container d-none d-sm-block" v-bind:style="{ backgroundImage : 'url(' + (category['acf']['desktop_image'] ? category['acf']['desktop_image'] : '/img/category-banner.png') + ')' }"></div>
                <div class="image-container d-block d-sm-none" v-bind:style="{ backgroundImage : 'url(' + (category['acf']['mobile_image'] ? category['acf']['mobile_image'] : (category['acf']['desktop_image'] ? category['acf']['desktop_image'] : '/img/category-banner.png')) + ')' }"></div>
                <div class="overlay"></div>
                <div class="heading" v-html="category['acf']['heading'] ? category['acf']['heading'] : category.name"></div>
            </div>
            <div class="container-fluid category-details">
                <h1 class="sub-heading" v-if="category['acf']['sub_heading']" v-html="category['acf']['sub_heading']"></h1>
                <div class="short-text" v-if="category['acf']['short_text']" v-html="category['acf']['short_text']"></div>
            </div>
        </header>

        <tabbed-teaser v-if="showTabbedTeaser" :teaser-filter-params="teaserFilterParams" :show-categories-filter-param="false"></tabbed-teaser>

    </main>

</template>

<script>

    // console.log('Home');

    import TabbedTeaser from './TabbedTeaser.vue';
    import wpApi from '../services/wpApi';

    export default {
        created(){
            // loader.dequeueUpdateTimeoutInMs = 500;
            // this.$root.events.$on('loaded', (id)=>{
            //     this.$set(this.childrenLoaded, id, true);
            // });
            this.load();
        },
        destroyed(){
        },
        mounted(){
        },
        components : {
            TabbedTeaser
        },
        props : {
            'teaserFilterParams' : {
                default : {},
                type : Object,
            }
        },
        data(){
            return {
                // childrenLoaded : {},
                page : {
                  acf : {},
                },
                showTabbedTeaser: false,
                category: null,
                categoryParent: null
            };
        },
        metaInfo(){
            return {
                meta : [
                    {
                        vmid : 'description',
                        name : 'description',
                        content : this.page['acf']['meta_description'],
                    },
                    {
                        vmid : 'og:description',
                        property : 'og:description',
                        content : this.page['acf']['meta_og_description'],
                    },
                    {
                        vmid : 'og:image',
                        property : 'og:image',
                        content : this.page['acf']['meta_og_image_1200_630'],
                    },
                    {
                        vmid : 'og:image:alt',
                        property : 'og:image:alt',
                        content : this.page['acf']['meta_og_image_alt_text'],
                    },
                    {
                        vmid : 'og:title',
                        property : 'og:title',
                        content : this.page['acf']['meta_og_title'],
                    },
                ],
            };
        },
        methods : {
            load(){

                if(this.$route.params['parentcategory']){

                    wpApi.http.get(wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/categories/?slug='+this.$route.params['parentcategory']).then(parentResponse => {

                        if (Array.isArray(parentResponse.data) === false || parentResponse.data.length === 0) {
                            this.$router.push('/404');
                            return;
                        }
                        this.categoryParent = parentResponse.data[0];

                    }).catch( error => {
                        console.log('error', error);
                    });
                }

                wpApi.http.get(wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/categories/?slug='+this.$route.params['category']).then(response => {

                    if (Array.isArray(response.data) === false || response.data.length === 0) {
                        this.$router.push('/404');
                        return;
                    }
                    this.category = response.data[0];

                    if(this.categoryParent != null && this.categoryParent.id != this.category.parent){
                        this.categoryParent = null;
                    }

                    this.teaserFilterParams['categories'] = [this.category.id];
                    this.showTabbedTeaser = true;

                }).catch( error => {
                    console.log('error', error);
                });

                window.setTimeout(()=>{
                    try{
                      // this.$ga.page(this.$route.fullPath);
                      this.$gtm.trackEvent({
                          event : 'Pageview',
                          url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                      });
                    }catch (e){console.log(e);}
                });
            }
        },
    }

</script>

<style lang="scss">

@import '../../css/variables';

    .category-header {
        .heading-container {
            position: relative;
            height: 258px;
            margin-bottom: 30px;
            @media (min-width: 576px) {
                height: 480px;
            }
            @media (min-width: 768px) {
                margin-bottom: 60px;
            }
        }
        .image-container{
            background-color: rgba(0, 0, 0, 0.25);
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: cover;
            height: 258px;
            position: absolute;
            top:0;
            left: 0;
            right: 0;
            bottom: 0;
            &.d-sm-block{
                height: 480px;
            }
        }
        .overlay{
            background-color: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
        .heading {
            font-size: 27px;
            font-weight: bold;
            line-height: 1.2;
            color: $color-nochvielvor-white;
            text-transform: uppercase;
            position: absolute;
            left:24px;
            right: 24px;
            bottom: 30px;
            word-wrap: break-word;
            @media (min-width: 576px) {
                max-height: 480px;
                left:34px;
                right: 34px;
                top: 210px;
                font-size: 30px;
                line-height: 1.33;
            }
        }

        .sub-heading{
            font-size: 27px;
            font-weight: bold;
            line-height: 1.2;
            color: $color-nochvielvor-black;
            margin-bottom: 24px;
            @media (min-width: 768px) {
                font-size: 30px;
                line-height: 1.33;
                margin-bottom: 30px;
            }
        }

        .short-text{
            font-size: 12px;
            line-height: 1.6;
            color:$color-nochvielvor-black;
            @media (min-width: 768px) {
                font-size: 18px;
                line-height: 1.33;
                text-align: left;
                color: #2b2e34;
            }
        }

        .category-details {
            padding-left: 24px;
            padding-right: 24px;
            margin-bottom: 30px;
            @media (min-width: 576px) {
                padding-left: 34px;
                padding-right: 34px;
            }
            @media (min-width: 768px) {
                margin-bottom: 60px;
            }
        }
    }

    </style>



// WEBPACK FOOTER //
// public/js/components/Category.vue